import React from "react";
import styles from "./chartBySla.module.scss";
import { Col, Row } from "react-bootstrap";
import { ReactComponent as Objetos } from "../../../../../../assets/images/dashboard/objetos.svg";
import { BsClock } from "react-icons/bs";
import moment from 'moment'

const ChartBySla = ({ data, initialDateToRedirect, endDateToRedirect, countObjectsWithError, customClassName = '' }) => {
  const handleRedirect = (value, label) => {

    const initialDateFormated = moment(initialDateToRedirect).format('DD/MM/YYYY');
    const finalDateFormated = moment(endDateToRedirect).format('DD/MM/YYYY');

    if (value === 'processCorreiosError') {
      return window.open(
        `/rastrear-encomenda?status=${value}&label=${label}`,
        "_blank"
      );
    }

    let path = ""

    if (value.includes("status")) {
      path = `/rastrear-encomenda?value=${value.replace(/\D/g, '')}&label=${label}&initialDate=${initialDateFormated}&finalDate=${finalDateFormated}`
    } else {
      path = `/rastrear-encomenda?status=${value}&label=${label}&initialDate=${initialDateFormated}&finalDate=${finalDateFormated}`
    }

    window.open(
      path,
      "_blank"
    );
  };

  const deliveredBeforeAndOnTime = (data?.DELIVERED_ON_TIME?.value ?? 0) + (data?.DELIVERED_BEFORE?.value ?? 0)

  const allDelivered = deliveredBeforeAndOnTime + (data?.DELIVERED_LATER?.value ?? 0)

  const sla = allDelivered === 0 ? NaN : (deliveredBeforeAndOnTime / allDelivered) * 100

  const handleSlaPercentage = (sla) => {
    if (typeof sla !== "number" || isNaN(sla)) {
      return "--";
    }

    return `${sla.toFixed(2)}%`;
  };

  return (
    <>
      <Row xs={{ cols: 2 }} lg={{ cols: 4 }} className={`${styles.cardsStatus} ${customClassName}`}>
        <>
          <Col xs={12} lg={3}>
            <div
              className={`${styles.card} ${styles.cardTotal}`}
              onClick={() => handleRedirect("", "Selecione")}
            >
              <div className={styles.information}>
                <h3>Performance de Entrega</h3>
                <h1>
                  {handleSlaPercentage(sla)}
                </h1>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={3}>
            <div
              className={`${styles.card} ${styles.cardTotal}`}
              onClick={() => handleRedirect("status-10", "Entrega realizada")}
            >
              <div className={styles.information}>
                <h3>Objetos Entregues</h3>
                <h1>
                  {Intl.NumberFormat("pt-BR").format(data?.TOTAL_DELIVERED?.value ?? 0)}
                </h1>
              </div>
            </div>
          </Col>
          <Col className={styles.statusContainer} xs={12} lg={6}>
            <div
              className={`${styles.card} ${styles.cardStatus} ${styles.onTime}`}
              onClick={() => handleRedirect("slaOn_time", "Dentro do prazo")}
            >
              <div className={styles.cardStatusHeader}>
                <BsClock color="#409e6a" />
                <p>
                  <strong>Dentro do prazo</strong>
                </p>
              </div>
              <h3>
                {Intl.NumberFormat("pt-BR").format(data.DELIVERED_ON_TIME.value)}
              </h3>
            </div>
            <div
              className={`${styles.card} ${styles.cardStatus} ${styles.before}`}
              onClick={() => handleRedirect("slaEarlier", "Antes do prazo")}
            >
              <div className={styles.cardStatusHeader}>
                <BsClock color="#f5cb2b" />
                <p>
                  <strong>Antes do prazo</strong>
                </p>
              </div>
              <h3>
                {Intl.NumberFormat("pt-BR").format(data.DELIVERED_BEFORE.value)}
              </h3>
            </div>
            <div
              className={`${styles.card} ${styles.cardStatus} ${styles.later}`}
              onClick={() => handleRedirect("slaDelayed", "Fora do prazo")}
            >
              <div className={styles.cardStatusHeader}>
                <BsClock color="#ca1818" />
                <p>
                  <strong>Fora do prazo</strong>
                </p>
              </div>
              <h3>
                {Intl.NumberFormat("pt-BR").format(data.DELIVERED_LATER.value)}
              </h3>
            </div>
          </Col>
        </>
      </Row>
    </>
  );
};

export { ChartBySla };
